import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-dermatomas',
  templateUrl: './dermatomas.component.html',
  styleUrls: ['./dermatomas.component.css']
})
export class DermatomasComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  img: string;

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.getImagen();
  }

  async getImagen() {
    const request = await this.servicioFormato.getImagenNodo(this.filtros.codigoBaseDatos, this.filtros.entidadEmpresarial.unco, this.filtros.tta, this.nodo.id);
    request.subscribe((data: any) => {
      this.img = data.source;
    }, (err: HttpErrorResponse) => {
      this.img = null;
      console.error('Error Dermatomas', err);
    });
  }

}
